import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, MessageCircle, User, Wallet } from 'lucide-react';

const NAV_ITEMS = [
  { to: '/lounge', label: 'Lounge', Icon: Home },
  { to: '/chats', label: 'Chats', Icon: MessageCircle },
  { to: '/wallet', label: 'Wallet', Icon: Wallet, altTo: '/earnings' },
  { to: '/profile', label: 'Profile', Icon: User },
];

export default function BottomNav() {
  const { pathname } = useLocation();

  const isActive = (item) => {
    if (pathname === item.to || pathname.startsWith(`${item.to}/`)) {
      return true;
    }
    if (item.altTo && (pathname === item.altTo || pathname.startsWith(`${item.altTo}/`))) {
      return true;
    }
    return false;
  };

  return (
    <nav className="ic-bottom-nav" aria-label="Primary">
      <div className="ic-bottom-nav-inner">
        {NAV_ITEMS.map(({ Icon, ...item }) => (
          <Link key={item.label} to={item.to} className={`ic-nav-item ${isActive(item) ? 'active' : ''}`}>
            <span className="ic-nav-icon" aria-hidden="true"><Icon size={22} strokeWidth={1.8} /></span>
            <span className="ic-nav-label">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
